import ACTIONS from 'state/constants';
import GENERIC_CTA_CLICKED_EVENT from 'utils/Rudderstack/constants';

export const trackNotFoundPageEvent =
  ({ eventLabel, eventLocation }) =>
  dispatch => {
    dispatch({
      type: ACTIONS.TRACK_CTA_CLICK_EVENT,
      payload: {
        type: GENERIC_CTA_CLICKED_EVENT.TYPES.BUTTON,
        location: GENERIC_CTA_CLICKED_EVENT.LOCATIONS.NOT_FOUND,
        url: eventLocation,
        name: eventLabel,
      },
    });
  };
